import React from 'react';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, IconButton } from '@mui/material';

interface FeederColumnGroupHeaderProps {
  code: string;
  isFixed: boolean;
  isViewMode: boolean;
  onDelete: (code: string) => void;
}

export default function FeederColumnGroupHeader({
  code,
  isFixed,
  isViewMode,
  onDelete,
}: FeederColumnGroupHeaderProps): React.JSX.Element {
  if (isViewMode || isFixed) {
    return (
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box component="span">{code}</Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '32px 1fr 32px',
        alignItems: 'center',
        px: 0.25,
      }}
    >
      <Box />
      <Box component="span" sx={{ textAlign: 'center' }}>
        {code}
      </Box>
      <IconButton
        size="small"
        color="error"
        sx={{ justifySelf: 'end' }}
        aria-label={`Delete feeder column ${code}`}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onDelete(code);
        }}
      >
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
